import SubcategoryPage from 'components/pages/Subcategory';

import { resolvify } from 'lib/promises';

import { getAds } from 'services/ads';
import {
  getCategoriesList,
  getSubcategoryInfo,
  getSubcategoryOffersList,
} from 'services/category';
import { getCouponFeaturedStoresList } from 'services/coupon';
import { getLandingsList } from 'services/landing';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import CATEGORY from 'constants/category';
import LINKS from 'constants/links';

const Subcategory = (props) => {
  /**
   * During Server-Side Rendering (SSR) when Next.js
   * tries to render the component for error generation/stack traces,
   * it sometimes calls the component with undefined props. The
   * `catch` block in `getServerSideProps` redirects on error, but
   * there's  probably a race condition where Sentry's
   * `wrapPageComponentWithSentry` tries to render the component before
   * the redirect happens, passing `undefined as props. We just return
   * `null` to avoid the error when this happens.
   */
  if (!props?.subcategory) {
    return null;
  }

  const { featuredStores, isDeepSubcategory, serverOffers, subcategory } =
    props;

  return (
    <SubcategoryPage
      featuredStores={featuredStores}
      isDeepSubcategory={isDeepSubcategory}
      serverOffers={serverOffers}
      subcategory={subcategory}
    />
  );
};

export const getServerSideProps = async ({
  query,
  params: { categorySlug: subcategorySlug },
}) => {
  try {
    const [
      subcategory,
      serverOffers,
      featuredStores,
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getSubcategoryInfo({
        subcategorySlug,
      }),
      getSubcategoryOffersList({
        limit: CATEGORY.OFFERS.SERVER_LIMIT,
        subcategorySlug,
        ...query,
      }),
      {
        fn: getCouponFeaturedStoresList(),
        fallback: getCouponFeaturedStoresList.fallback,
      },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    return {
      props: {
        featuredStores,
        serverOffers,
        subcategory,
        isDeepSubcategory: !subcategory.category.subcategories.find(
          ({ isSelected }) => isSelected
        ),
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[404], permanent: false } };
  }
};

export default Subcategory;
